import { createContext } from 'react';
import {
    ClaimRequest,
    GapClaimType,
    ProductType
} from '../components/common/CommonTypes';

export type ClaimState = {
    gapClaim: GapClaimType;
    productReference: ProductType;
    claimRequest: ClaimRequest;
};

export type ClaimContextState = {
    gapClaim: GapClaimType;
    productReference: ProductType;
    claimRequest: ClaimRequest;
    setGapClaim: (claim: GapClaimType) => void;
    setGapProductReference: (productReference: ProductType) => void;
    setClaimRequest: (req: ClaimRequest) => void;
};

const initialState: ClaimContextState = {
    gapClaim: {},
    productReference: null,
    claimRequest: null,
    setGapClaim: undefined,
    setGapProductReference: undefined,
    setClaimRequest: undefined
};

export const ClaimContext = createContext(initialState);
